<template>
  <div id="app">
    <HomePage></HomePage>
  </div>
</template>

<script>
import HomePage from './page/homePage.vue'
export default {
  name: 'App',
  components: {
    HomePage
  }
}
</script>

<style>
@import "./common/common.css";
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  text-align: center;
  width: 100%;
  height: 100%;
  /* margin-top: 60px; */
}
</style>
